import { useId } from 'react'
import page from '@/pages/NewDeploymentPage.module.css'

interface CheckboxFieldProps {
  label: string
  checked: boolean
  onChange: (checked: boolean) => void
  /** A second line under the label, for example the script parameter's name. */
  description?: string
  disabled?: boolean
}

/** A labelled checkbox: a real input, so the keyboard and screen readers behave natively. */
export function CheckboxField({ label, checked, onChange, description, disabled }: CheckboxFieldProps) {
  const id = useId()
  return (
    <div className={page.formGroup} style={{ marginBottom: 6 }}>
      <label htmlFor={id} style={{ display: 'flex', gap: 8, alignItems: 'flex-start', cursor: disabled ? 'default' : 'pointer' }}>
        <input id={id} type="checkbox" checked={checked} disabled={disabled} onChange={(event) => onChange(event.target.checked)} style={{ marginTop: 3 }} />
        <span>
          <span className={page.label} style={{ display: 'inline' }}>
            {label}
          </span>
          {description && (
            <span className={page.fieldHint} style={{ display: 'block', fontFamily: 'monospace' }}>
              {description}
            </span>
          )}
        </span>
      </label>
    </div>
  )
}
